import { render, staticRenderFns } from "./SA.vue?vue&type=template&id=8ccae122&scoped=true&"
import script from "./SA.vue?vue&type=script&lang=ts&"
export * from "./SA.vue?vue&type=script&lang=ts&"
import style0 from "./SA.vue?vue&type=style&index=0&id=8ccae122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccae122",
  null
  
)

export default component.exports